import { pushVisit } from './api';
import { Translate } from './api/pushVisit';
import {
    amIDoctor,
    getCompletedVisitById,
    getDoc,
    getItemFromMisc,
    getPrescriptionById,
    getPrintConfig,
    MISC_KEYS,
} from './store/idbHandler';
import { track } from './tracking';

const BACK_FILL_PX_IDS: {
    [docid: string]: {
        prescription_id: string;
    }[];
} = {
    '173744355707964': [{ prescription_id: 'P-DW-A0279204-5FAC-59D2-BBEC-E82F5D98F608' }],
    '173858902890446': [{ prescription_id: 'P-DW-E4C68CE6-72BC-5C93-A3B8-7E81AEDAA899' }],
    '173858903882428': [{ prescription_id: 'P-DW-DD4F39F8-C63D-5ACE-864B-F84BA3E1CBCF' }],
    '173858923072744': [{ prescription_id: 'P-DW-45E43243-4C48-5126-B94F-302C24D24E9C' }],
    '173858928113514': [{ prescription_id: 'P-DW-F682F2CF-6FE2-58FE-8368-216EE4E01B64' }],
    '173858930470144': [{ prescription_id: 'P-DW-F682F2CF-6FE2-58FE-8368-216EE4E01B64' }],
    '173858931681566': [{ prescription_id: 'P-DW-3E5FB695-1726-53FA-ACF8-4BB1BDF5E5F8' }],
    '173858935399625': [{ prescription_id: 'P-DW-2B93185C-581D-5734-A681-7B588233B33C' }],
    '173858915162266': [{ prescription_id: 'P-DW-669DB7FC-2BC0-538D-AACA-4992EAB8E00E' }],
    '173858936963555': [{ prescription_id: 'P-DW-E76C993E-70B6-53C8-93DE-31BE4D1722B9' }],
    '174531132532193': [{ prescription_id: 'P-DW-67B77A80-9773-53C9-89C4-B0167B5D3798' }],
};
const backFillPx = async (): Promise<void> => {
    if (!amIDoctor()) {
        console.log('Not a doctor');
        return;
    }

    if (localStorage.getItem('Px_back_filled_4') === 'true') {
        track('BACK_FILL_PX', { message: 'Px_back_filled_4 from localstorage' });
        return;
    }

    try {
        const printCofig = await getPrintConfig(getDoc()?._id || '');
        const translate = await getItemFromMisc<Translate>(
            getDoc()?._id || '',
            MISC_KEYS.translate,
        );

        const doc = getDoc();
        if (!doc) {
            track('BACK_FILL_PX', { message: 'No doc' });
            return;
        }

        const backFillPx = BACK_FILL_PX_IDS[doc._id] || [];

        track('BACK_FILL_PX', { message: `Found ${backFillPx.length} px to backfill` });

        for (const item of backFillPx) {
            const px = await getPrescriptionById(item.prescription_id);

            if (!px) {
                track('BACK_FILL_PX', {
                    message: `Px not Found with id ${item.prescription_id} px`,
                    prescription_id: item.prescription_id,
                });
                continue;
            }

            const v = await getCompletedVisitById(px.visitId);
            if (!v) {
                track('BACK_FILL_PX', {
                    message: `completed Visit not Found with id ${px.visitId} px`,
                    prescription_id: item.prescription_id,
                });
                continue;
            }

            if (v.isCompleted !== 1) {
                track('BACK_FILL_PX', {
                    message: `isCompleted Visit not Found with id ${px.visitId} px`,
                    prescription_id: item.prescription_id,
                    visitId: v.id,
                    isCompleted: v.isCompleted.toString(),
                });
                continue;
            }

            const res = await pushVisit(
                px,
                v.startedAt || new Date(),
                v.endedAt || new Date(),
                'send',
                printCofig,
                translate,
            );

            if (res.status === 'success') {
                track('BACK_FILL_PX', {
                    message: `Px ${px.id} back filled`,
                });
            } else {
                track('BACK_FILL_PX', {
                    message: `Px ${px.id} back filled FAILED res: ${res}`,
                });
            }
        }

        localStorage.setItem('Px_back_filled_4', 'true');
    } catch (e) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        track('BACK_FILL_PX', { message: `Catch error: ${e.message}` });
    }
};

export default backFillPx;
